import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/context/AuthContext';

export const use2FAAuth = () => {
  const { user } = useAuth();
  const [is2FAEnabled, setIs2FAEnabled] = useState<boolean>(false);
  const [is2FAVerified, setIs2FAVerified] = useState<boolean>(false);
  const [needsSetup, setNeedsSetup] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const check2FAStatus = async () => {
      if (!user) {
        setIsLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('admin_2fa_secrets')
          .select('enabled, verified_at')
          .eq('user_id', user.id)
          .single();

        if (error && error.code !== 'PGRST116') {
          console.error('Erro ao verificar 2FA:', error);
          setNeedsSetup(true);
        } else if (!data) {
          setNeedsSetup(true);
        } else {
          setIs2FAEnabled(data.enabled);
          
          const thirtyMinutesAgo = new Date(Date.now() - 30 * 60 * 1000);
          const verifiedAt = data.verified_at ? new Date(data.verified_at) : null;
          
          setIs2FAVerified(
            verifiedAt !== null && verifiedAt > thirtyMinutesAgo
          );
        }
      } catch (error) {
        console.error('Erro ao verificar status 2FA:', error);
        setNeedsSetup(true);
      } finally {
        setIsLoading(false);
      }
    };

    check2FAStatus();
  }, [user]);

  const mark2FAVerified = () => {
    setIs2FAVerified(true);
  };

  return { 
    is2FAEnabled, 
    is2FAVerified, 
    needsSetup, 
    isLoading,
    mark2FAVerified 
  };
};
